<div class="row text-center animated fadeIn mt-4 mb-4">
  <div class="col">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>
